export default __webpack_public_path__ + "static/media/Facebook.c8b11029.svg";